import type {CellContext, RowData} from "@tanstack/react-table";

import {Badge} from "@pg-design/badge-module";

import * as styles from "./DataTableCellBooleanStatusRenderer.module.css";

export const DataTableCellBooleanStatusRenderer = <TData extends RowData>(props: CellContext<TData, boolean>) => {
    const value = props.getValue();

    const variant = value ? "label_success" : "label_warning";

    return (
        <Badge className={styles.badge} variant={variant}>
            {value ? "tak" : "nie"}
        </Badge>
    );
};
import type {CellContext, RowData} from "@tanstack/react-table";

import {Badge} from "@pg-design/badge-module";

import * as styles from "./DataTableCellBooleanStatusRenderer.module.css";

export const DataTableCellBooleanStatusRenderer = <TData extends RowData>(props: CellContext<TData, boolean>) => {
    const value = props.getValue();

    const variant = value ? "label_success" : "label_warning";

    return (
        <Badge className={styles.badge} variant={variant}>
            {value ? "tak" : "nie"}
        </Badge>
    );
};
